import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsIssueLayoutRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-issue-layout',
	path: '/plugins/servlet/project-config/:projectKey/issuelayout',
};
